import { render, staticRenderFns } from "./listadoregistrosapp.vue?vue&type=template&id=35439112"
import script from "./listadoregistrosapp.vue?vue&type=script&lang=js"
export * from "./listadoregistrosapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports